import React from 'react';

import { Button, Modal } from '@/components';
import { useTranslation } from 'react-i18next';

import styles from './Modals.module.css';

interface CheckAddressModalProps {
  data: Api.ShippingAddress | undefined;
  onChangeData: () => void;
  onConfirm: () => void;
}

function CheckAddressModal({ onConfirm, data, onChangeData }: CheckAddressModalProps) {
  const { t } = useTranslation();

  return (
    <Modal closeButton={false} modalStyles={{ maxWidth: '480px' }}>
      <div className={styles.welcomeModal}>
        <h2 className={`${styles.welcomeModalTitle} ${styles.BottomMarginSm}`}>
          {t('inviteView.checkAddressModal.title')}
        </h2>
        <div className={styles.welcomeModalDescription}>
          {t('inviteView.checkAddressModal.description')}
        </div>
        <div className={`${styles.welcomeModalBody} ${styles.welcomeModalBodyAddress}`}>
          <p>{data?.name}</p>
          <p>{data?.address1}</p>
          <p>{`${data?.postal_code} ${data?.city}`}</p>
          <p>{data?.country}</p>
        </div>
        <div className={styles.addressModalButtonFlex}>
          <Button onClick={onChangeData}>{t('inviteView.checkAddressModal.changeButton')}</Button>
          <Button theme="cta" onClick={onConfirm}>
            {t('inviteView.checkAddressModal.confirmButton')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default CheckAddressModal;
